// import { MatxLoading } from 'app/components';
import { Suspense } from 'react';
import { MatxLoading } from '.';

const MatxSuspense = ({ children }) => {
  return <Suspense fallback={<MatxLoading />}>{children}</Suspense>;
};

export default MatxSuspense;
